<template>
  <div class="patient-routine-list__container">
    <modal
      ref="loadingModal"
      template="loading"
      title="Aguarde"
      ref-name="loadingModal"
    >
      <p>Salvando alterações.</p>
    </modal>

    <modal
      ref="deleteOrderModal"
      template="question"
      ref-name="deleteOrderModal"
      first-button-text="Cancelar"
      second-button-text="Excluir"
      :close-button-enabled="true"
      @first-cta="closeConfirmOrder"
      @second-cta="confirmDeleteOrder(orders.indexOf(orderForExclusion))"
    >
      <p>Deseja excluir a OS {{ orderForExclusion ? orderForExclusion.code_lis : null }}?</p>
    </modal>

    <modal
      ref="insertExamAfterTransferred"
      title="Incluir novo exame na ordem de serviço transferida"
      template="question"
      ref-name="insertExamAfterTransferred"
      first-button-text="Cancelar"
      second-button-text="Confirmar"
      :close-button-enabled="true"
      :icon-enabled="false"
      :second-button-disabled="newExamsList.length == 0"
      size="large"
      class="include-exam-after-transferred"
      @first-cta="closeInclusionExamModal()"
      @second-cta="includeExamAfterTransferred(orderEditAfterTransferred)"
    >
      <include-exam-after-transferred :order="orderEditAfterTransferred" />
    </modal>

    <table class="apoio-datatable white-head">
      <colgroup>
        <col class="column-check">
        <col class="column-status">
        <col class="column-date">
        <col class="column-name">
        <col class="column-cpf">
        <col class="column-diabetes">
        <col class="column-treatment">
        <col class="column-collect-time">
        <col class="column-transfer">
        <col class="column-document">
        <col class="column-expander">
      </colgroup>
      <thead>
        <tr class="apoio-datatable__header-line">
          <!-- 1 header check -->
          <th
            id="chkOrdersSelectAll"
            class="column-check"
          >
            <div class="styled-checkbox">
              <input
                id="checkOrderSelectAllElement"
                v-model="selectAll"
                type="checkbox"
              >
              <label for="checkOrderSelectAllElement" />
            </div>
            <md-tooltip
              md-delay="400"
              md-direction="right"
            >
              Selecionar todos
            </md-tooltip>
          </th>

          <!-- 2 header status -->
          <th class="column-status" />

          <!-- 3 header date -->
          <th
            title="DATA"
            class="sort-column column-date"
            @click.prevent="sortColumn('date')"
          >
            DATA
            <sort-column id="date" />
          </th>

          <!-- 4 header patient name -->
          <th
            title="PACIENTE"
            class="sort-column column-pacient"
            @click.prevent="sortColumn('patient', 'name')"
          >
            PACIENTE
            <sort-column id="patient" />
          </th>

          <!-- 5 header patient CPF -->
          <th
            title="CPF"
            class="sort-column column-cpf"
            @click.prevent="sortColumn('cpf')"
          >
            CPF
            <sort-column id="cpf" />
          </th>

          <!-- 6 header diabetes -->
          <th
            title="DIABETES"
            class="sort-column column-diabetes"
            @click.prevent="sortColumn('diabetes')"
          >
            DIABETES
            <sort-column id="diabetes" />
          </th>

          <!-- 7 header treatment -->
          <th
            title="TRATAMENTO"
            class="sort-column column-treatment"
            @click.prevent="sortColumn('treatmentType')"
          >
            TRATAMENTO
            <sort-column id="treatmentType" />
          </th>

          <!-- 8 header collect time -->
          <th
            title="HORÁRIO/COLETA"
            class="sort-column column-collect-time"
            @click.prevent="sortColumn('sickSchedule')"
          >
            HORÁRIO/COLETA
            <sort-column id="sickSchedule" />
          </th>

          <!-- 9 header transfer action -->
          <th class="column-transfer" />

          <!-- 10 header document -->
          <th class="column-document" />

          <!-- 11 header show detail -->
          <th class="column-expander" />
        </tr>
      </thead>
    </table>

    <table class="apoio-datatable apoio-datatable-alt">
      <colgroup>
        <col class="column-check">
        <col class="column-status">
        <col class="column-date">
        <col class="column-name">
        <col class="column-cpf">
        <col class="column-diabetes">
        <col class="column-treatment">
        <col class="column-collect-time">
        <col class="column-transfer">
        <col class="column-document">
        <col class="column-expander">
      </colgroup>
      <template v-if="filteredArray.length">
        <tbody
          v-for="(order, rowIndex) in filteredArray"
          :key="rowIndex"
          :md-item="order"
        >
          <tr
            :id="'order' + order.id"
            :class="[{ expanded: order.expanded }, { incorrect: (order.status === ORDER_STATUS_ERROR) }]"
            class="apoio-datatable__line apoio-datatable-alt"
            @click="toggleActions(order.expanded, order.id)"
          >
            <!-- 1 cell check item -->
            <td class="column-check">
              <div class="styled-checkbox">
                <input
                  :id="'chk' + order.id"
                  v-model="selected"
                  type="checkbox"
                  :disabled="!orderCanBeTransmitted(order)"
                  :value="order.id"
                >
                <label
                  class="list-checkbox"
                  :for="'chk' + order.id"
                  :disabled="!orderCanBeTransmitted(order)"
                />
              </div>
            </td>

            <!-- 2 cell status -->
            <td
              class="column-status"
              @click.prevent="openOrderDetails(order)"
            >
              <span>
                <div :class="getStatus(order.status)">
                  <md-tooltip
                    md-delay="400"
                    md-direction="top"
                    v-html="getStatusText(order.status)"
                  />
                </div>
              </span>
            </td>

            <!-- 3 cell date -->
            <td
              class="column-date"
              @click.prevent="openOrderDetails(order)"
            >
              <span :title="order.date | formatDate">{{ format(order.date) }}</span>
            </td>

            <!-- 4 cell name -->
            <td
              class="column-pacient"
              @click.prevent="openOrderDetails(order)"
            >
              <span
                :title="order.patient.name"
                class="patient-name-span"
              >{{ order.patient.name }}</span>
            </td>

            <!-- 5 cell cpf -->
            <td
              class="column-cpf"
              @click.prevent="openOrderDetails(order)"
            >
              <span
                :title="order.patient.cpf"
                class="patient-cpf-span"
              >{{ order.patient.cpf }}</span>
            </td>

            <!-- 6 cell diabetes -->
            <td
              class="column-diabetes"
              @click.prevent="openOrderDetails(order)"
            >
              <span :title="order.diabetes ? 'Sim' : 'Não'">
                {{ order.diabetes ? 'Sim' : 'Não' }}
              </span>
            </td>

            <!-- 7 cell treatment -->
            <td
              class="column-treatment"
              @click.prevent="openOrderDetails(order)"
            >
              <span :title="order.treatmentType">{{ order.treatmentType }}</span>
            </td>

            <!-- 8 cell collectTime -->
            <td
              class="column-collect-time"
              @click.prevent="openOrderDetails(order)"
            >
              <span :title="order.sickSchedule + ' / ' + order.stationRoom">
                {{ order.sickSchedule + ' / ' + order.stationRoom }}
              </span>
            </td>

            <!-- 9 cell transfer -->
            <td
              class="column-transfer"
              @click.prevent="openOrderDetails(order)"
            >
              <button
                v-if="!isOrderTransfering(order)"
                :id="'btn' + order.id"
                class="patient-routine-list__btn-transfer"
                :class="'order-state-button__' +
                  $strings.orderStates[order.state].state +
                  '--' +
                  $strings.orderStatus[order.status || ORDER_STATUS_ERROR].status"
                @click.stop.prevent="transferIndividualOrder(order.id, $strings.orderStates[order.state].state)"
              >
                <md-tooltip
                  v-if="order.state === 'T'"
                  md-delay="400"
                  md-direction="top"
                >
                  TRANSFERIDO
                </md-tooltip>
                <md-tooltip
                  v-else
                  md-delay="400"
                  md-direction="top"
                >
                  TRANSFERIR
                </md-tooltip>
                <img
                  :src="transferIconUrl(order)"
                  alt="icone transferir"
                >
              </button>
            </td>

            <!-- 10 cell document -->
            <td
              class="column-document"
              @click.prevent="openOrderDetails(order)"
            >
              <document-icon
                v-if="order.docRequired"
                :is-document-delivered="order.docDelivered"
              />
            </td>

            <!-- 11 cell show detail -->
            <td
              class="open-order-details column-expander"
              @click.prevent="openOrderDetails(order)"
            >
              <div v-if="order.loading">
                <spinner class="small" />
              </div>
              <div
                v-if="!order.loading"
                class="status-icon icon-arrow-dropdown-alt"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Detalhes
                </md-tooltip>
              </div>
            </td>
          </tr>

          <div class="column-action">
            <div class="patient-routine-list__action">
              <div
                v-if="orderCanBeCloned(order)"
                class="patient-routine-list__action-clone"
                @click="cloneOrder(order)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Clonar
                </md-tooltip>
              </div>
              <div
                v-if="orderCanBeEdited(order)"
                class="patient-routine-list__action-edit"
                @click="handleEdit(order.id)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Editar
                </md-tooltip>
              </div>
              <div
                v-else
                class="patient-routine-list__action-edit"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Edição não permitida
                </md-tooltip>
              </div>
              <div
                v-if="orderCanBeExcluded(order)"
                class="patient-routine-list__action-delete"
                @click.capture.stop="openConfirmDeleteOrder(order)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
              </div>
              <div
                v-else
                class="patient-routine-list__action-delete"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Exclusão <br>não permitida
                </md-tooltip>
              </div>
            </div>
          </div>

          <!-- Detail row -->
          <tr
            v-if="order.expanded"
            class="row-details-alt"
          >
            <td
              class="row-details-alt___container"
              colspan="11"
            >
              <order-details :order="order" />
            </td>
          </tr>
        </tbody>
      </template>
      <template v-if="orderLoadingStatus === 'STATUS_END' && !filteredArray.length">
        <tbody>
          <tr>
            <td
              colspan="11"
              style="padding: 30px"
            >
              Sem resultados encontrados
            </td>
          </tr>
        </tbody>
      </template>

      <tfoot
        v-if="orderLoadingStatus !== 'STATUS_END'"
        class="on-finite"
      >
        <tr>
          <td colspan="11">
            <infinite-loading
              ref="infiniteLoading"
              @infinite="onInfinite()"
            >
              <span slot="no-more" />
              <span slot="no-results" />
              <span slot="spinner">
                <spinner />
              </span>
            </infinite-loading>
          </td>
        </tr>
        <tr
          v-if="totalOrders >= 1000"
          class="on-finite__message-container"
        >
          <td colspan="11">
            <loading-infinite-message
              :break-loading="breakOrdersLoading"
              :update-status-count="getTotalOrder"
            />
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import OrderDetails from '@/components/Orders/OrderDetails'
import Spinner from '@/components/common/Spinner'
import { mapActions, mapGetters } from 'vuex'
import { formatDate } from '@/utils/date-utils'
import { concatNameAndCode } from '@/utils/string-utils'
import ProgressBar from '@/components/common/ProgressBar'
import SortColumn from '@/components/common/SortColumn'
import { setSortation } from '@/utils/sort-columns'
import loadingInfiniteMessage from '@/components/common/LoadingInfiniteMessage'
import notify from '@/api/notification'
import IncludeExamAfterTransferred from '@/components/Orders/IncludeExamAfterTransferred'
import DocumentIcon from '@/components/Documents/Laboratory/Flag'
import fuzzysort from 'fuzzysort'
import {
  ORDER_STATE_TRANSMITTED,
  ORDER_STATUS_ERROR,
  ORDER_STATUS_FIXED,
  ORDER_STATUS_CORRECT,
  ORDER_STATE_RECEIVED,
  ORDER_STATE_VALIDATED,
  ORDER_STATE_PENDING_TRANSMISSION
} from '@/enums'

export default {
  name: 'PatientRoutineList',
  components: {
    'infinite-loading': InfiniteLoading,
    spinner: Spinner,
    'order-details': OrderDetails,
    'progress-bar': ProgressBar,
    'sort-column': SortColumn,
    'loading-infinite-message': loadingInfiniteMessage,
    'document-icon': DocumentIcon,
    'include-exam-after-transferred': IncludeExamAfterTransferred
  },
  props: ['resetSelectListForIndividualTransfer', 'reload', 'filterInput'],
  data: () => ({
    ORDER_STATUS_ERROR: ORDER_STATUS_ERROR,
    ORDER_STATE_TRANSMITTED: ORDER_STATE_TRANSMITTED,
    ORDER_STATUS_FIXED: ORDER_STATUS_FIXED,
    ORDER_STATUS_CORRECT: ORDER_STATUS_CORRECT,
    ORDER_STATE_PENDING_TRANSMISSION: ORDER_STATE_PENDING_TRANSMISSION,
    ORDER_STATE_VALIDATED: ORDER_STATE_VALIDATED,
    orderForExclusion: null,
    selected: [],
    transfering: true,
    progress: 0,
    processoValue: 0,
    indexUpdated: null,
    orderForTransfer: null,
    orderForTransferStatus: null,
    columnSortStatusOrders: {
      status: 'asc',
      date: 'asc',
      name: 'asc',
      cpf: 'asc',
      diabetes: 'asc',
      treatment: 'asc',
      collectTime: 'asc'
    },
    orderTransfering: null,
    orderEditAfterTransferred: null,
    fobiddenExamsTemplates: ['PATERNITY', 'CURVE']
  }),
  methods: {
    ...mapActions([
      'orderPatientRoutine',
      'getExamDetails',
      'setOrderClone',
      'getServiceOrder',
      'getServiceOrderDetails',
      'deleteOrder',
      'loadingDetails',
      'clearAllOrderData',
      'setWaitingOSLoadingStatus',
      'performTransferOs',
      'performTransferButton',
      'checkHasBatchOpened',
      'sortOSList',
      'getTotalOrder',
      'breakOrdersLoading',
      'getMostSentExam',
      'openExamCard',
      'includeNewExamAfterTransferred',
      'clearAllNewOrderData'
    ]),
    handleEdit(id) {
      this.$router.push({
        path: '/orders/edit/' + id,
        query: {
          profile: true
        }
      })
    },
    getStatusText(status) {
      if (this.$strings.orderStatus[status]) {
        return this.$strings.orderStatus[status].translated
      }
    },
    getStatus(status) {
      let text = ''
      if (status) {
        text = this.$strings.orderStatus[status].status
        text = text.toLowerCase()
      }
      return text
    },
    sortColumn(column, columnChild) {
      this.columnSortStatusOrders[column] = setSortation(
        column,
        columnChild,
        this.columnSortStatusOrders,
        this.sortOSList
      )
      this.pushEventToAnalytics('Ordenação da coluna ' + column)
    },
    format(v) {
      return formatDate(v)
    },
    onInfinite() {
      this.getTotalOrder()
      this.getServiceOrder()
    },
    openConfirmDeleteOrder(order) {
      this.orderForExclusion = order
      this.$refs.deleteOrderModal.open()
    },
    closeConfirmOrder() {
      this.$refs.deleteOrderModal.close()
    },
    confirmDeleteOrder(index) {
      this.deleteOrder(index)
      this.selected = this.selected.filter(
        e => e !== this.orderForExclusion.id
      )
      this.closeConfirmOrder()
      this.pushEventToAnalytics('Deletar OS - individual')
    },
    collectAllExamIds() {
      let allIdExams = new Set()
      if (this.orders) {
        for (let i = 0; i < this.orders.length; i++) {
          let os = this.orders[i]
          for (let j = 0; j < os.exams.length; j++) {
            allIdExams.add(os.exams[j].id)
          }
        }
      }
      return allIdExams
    },
    openOrderDetails(order) {
      if (!order.loading) {
        this.loadingDetails(this.orders.indexOf(order))
      }
    },
    orderCanBeTransmitted(order) {
      let orderTransmiting = this.orderTransfering !== order.id
      let orderIncorrectReceived = order.state !== ORDER_STATE_RECEIVED
      let orderIncorrectStatus = order.status !== ORDER_STATUS_ERROR
      let orderInValidatedState = order.state === ORDER_STATE_VALIDATED
      return (
        orderInValidatedState &&
        orderIncorrectStatus &&
        orderIncorrectReceived &&
        orderTransmiting
      )
    },
    orderCanBeExcluded(order) {
      return order.state === ORDER_STATE_VALIDATED || order.state === ORDER_STATUS_FIXED
    },
    orderCanBeEdited(order) {
      return (
        (order.state === ORDER_STATE_VALIDATED && order.voucher === false) ||
        (order.state === ORDER_STATUS_FIXED && order.voucher === false)
      )
    },
    isOrderTransfering(order) {
      return this.orderTransfering === order.id
    },
    concatNameCode(name, code) {
      return concatNameAndCode(name, code)
    },
    transferIndividualOrder(orderById, status) {
      this.orderForTransfer = orderById
      this.orderForTransferStatus = status
      this.transformButtonToTransferingbyId(orderById, status)
    },
    startTransferById(orderById) {
      this.performTransferButton(orderById, this.orderForTransferStatus).then(
        () => {
          this.transfering = true
          this.doButtonStyleToTransfering(orderById)

          // Check if there is any Order in State = P (transfering) - if so, reloag the screen
          let isThereTransferingState = this.orders.findIndex(
            x => x.state === 'P'
          )
          if (isThereTransferingState < 0) {
            this.indexUpdated = this.orders.findIndex(x => x.id === orderById)
            this.orders.splice(this.indexUpdated, 1)
            this.orderTransfering = null
            if (this.orders[this.indexUpdated].status === ORDER_STATUS_CORRECT) {
              this.increaseSummary('corretas')
            } else if (this.orders[this.indexUpdated].status === ORDER_STATUS_ERROR) {
              this.increaseSummary('corrigidas')
            } else if (this.orders[this.indexUpdated].status === ORDER_STATUS_FIXED) {
              this.increaseSummary('erros')
            }
            this.increaseSummary('totalOs')
          } else {
            this.reload()
          }
          notify({
            title: 'AVISO:',
            message:
              'A ordem de serviço transferida está sendo enviada à lista de validação e estará disponível em breve'
          })
        }
      )
      this.resetSelectListForIndividualTransfer()
    },
    transformButtonToTransferingbyId(orderId, status) {
      if (status === 'VALIDATED') {
        this.startTransferById(orderId)
      }
    },
    increaseSummary(id) {
      var cont = document.getElementById(id).textContent
      var newcont = parseInt(cont) - 1
      document.getElementById(id).innerHTML = newcont
    },
    toggleActions(expanded, id) {
      let container = null
      if (this.$refs['order-actions-' + id]) {
        container = this.$refs['order-actions-' + id][0]
      }
      if (container) {
        if (expanded) {
          this.showActions(container)
        } else {
          this.hideActions(container)
        }
      }
    },
    showActions(container) {
      container.classList.add('actionshowing')
    },
    hideActions(container) {
      container.classList.remove('actionshowing')
    },
    closedTransferModalbyId() {
      this.$refs.transferModalbyId.close()
    },
    startTransferBatchesbyId(order) {
      this.transfering = true
      this.submitOpenBatchs()
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Listagem de OS - Listagem',
        'action': 'Transferir OS - Individual',
        'id-user': this.$profile.id,
        'id-lab': this.$profile.id_laboratory,
        'name-lab': this.$profile.laboratoryName
      })
    },
    submitOpenBatchs() {
      this.transformButtonToTransferingbyId(
        this.orderForTransfer,
        this.orderForTransferStatus
      )
      this.closedTransferModalbyId()
    },
    doButtonStyleToTransfering(orderId) {
      this.orderTransfering = orderId
    },
    refresh() {
      this.orderEditAfterTransferred = null
      this.clearAllOrderData()
      this.clearAllNewOrderData()
      this.selected = []
      if (this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
      }
    },
    includeExamAfterTransferred(order) {
      this.closeInclusionExamModal()
      this.$refs.loadingModal.open()
      this.includeNewExamAfterTransferred(order.id).then(response => {
        this.$refs.loadingModal.close()
        this.refresh()
      })
    },
    openInclusionExamModal(order) {
      this.orderEditAfterTransferred = order
      this.$refs.insertExamAfterTransferred.open()
    },
    closeInclusionExamModal() {
      this.$refs.insertExamAfterTransferred.close()
    },
    orderCanBeCloned(order) {
      if (order.status === ORDER_STATUS_ERROR) return false
      return true
    },
    cloneOrder(order) {
      this.setOrderClone(order.id)
      this.$router.push('/orders/new/')
      this.pushCloneInformationToAnalytics(order)
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Listagem de OS - Listagem',
        'action': action,
        'id-user': this.$profile.id,
        'id-lab': this.$profile.id_laboratory,
        'name-lab': this.$profile.laboratoryName
      })
    },
    pushCloneInformationToAnalytics(order) {
      if (this.$profile) {
        this.$analytics.pushAnalyticsEvent('ga-event', {
          'category': 'Listagem de OS - Listagem',
          'action': 'Clone de OS - clone da OS ID: ' + order.id,
          'label': order.exams.length,
          'id-user': this.$profile.id,
          'id-lab': this.$profile.id_laboratory,
          'name-lab': this.$profile.laboratoryName
        })
      }
    },
    isTransmited(state) {
      return state === ORDER_STATE_TRANSMITTED
    },
    transferIconUrl(order) {
      if (order.status === 'E' && order.state === 'V') {
        return '/static/images/icon-transfer-alt.svg'
      }
      let icon = this.$strings.orderStates[order.state].buttonIcon
      return icon
    }
  },
  computed: {
    ...mapGetters([
      'orders',
      'orderLoadingStatus',
      'profile',
      'totalOrders',
      'newExamsList',
      'preference'
    ]),
    filteredArray() {
      if (this.filterInput) {
        if (this.filterInput.length > 0) {
          if (this.orders) {
            var targets = this.orders.map((order) => {
              order.patientName = order.patient.name
              order.patientCPF = order.patient.cpf
              order.formatedDate = this.format(order.date)
              return order
            })
          }
          let result = fuzzysort.go(this.filterInput, targets, {
            keys: ['patientName', 'patientCPF', 'sickSchedule', 'stationRoom', 'formatedDate'],
            limit: 1000,
            allowTypo: true,
            threshold: -10000
          })
          result = result.map((item) => {
            item = item.obj
            return item
          })
          return result
        }
      } else {
        return this.orders
      }
    },
    selectAll: {
      get: function () {
        if (this.orders.length === 0) {
          return false
        }
        let self = this
        let ordersValidated = this.orders.filter(function (order) {
          return self.orderCanBeTransmitted(order)
        })
        return this.orders
          ? this.selected.length > 0 &&
          this.selected.length === ordersValidated.length
          : false
      },
      set: function (value) {
        var selected = []
        if (value) {
          let self = this
          this.filteredArray.forEach(function (order) {
            if (self.orderCanBeTransmitted(order)) {
              selected.push(order.id)
            }
          })
        }
        this.selected = selected
      }
    }
  },
  watch: {
    orderLoadingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_END':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_SUCCESS':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          this.setWaitingOSLoadingStatus()
          break
        case 'STATUS_FAILED':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_INITIAL':
          this.clearAllOrderData()
          this.selected = []
          if (this.$refs.infiniteLoading) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
          }
          break
        case 'STATUS_WAITING':
          break
        default:
          break
      }
    },
    selected: function (newValue) {
      this.$emit('update:selected', newValue)
    }
  },
  mounted() {
    this.getMostSentExam()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../static/stylesheets/mixins";

.patient-routine-list {
  &__container {
    .apoio-datatable__line {
      border: none !important;
    }

    .column-action {
      display: none;
      position: absolute;
      right: 10px;
      z-index: 1;
      top: -20px;
    }

    .apoio-datatable {
      tbody {
        position: relative;

        &:hover {
          .column-action {
            display: block;
          }
        }
      }
    }
  }

  &__action {
    display: flex;
    background: #7F1A54;
    align-items: center;
    justify-content: space-evenly;
    border-radius: 6px;
    height: 36px;
    padding: 4px 8px;

    >div {
      width: 28px;
      height: 28px;
      border-radius: 6px;
      background-repeat: no-repeat;
      background-position: center center;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
        cursor: pointer;
      }
    }
  }

  &__action-clone {
    background-image: url(/static/images/icon-clone.svg);
    background-size: 16px 18px;
  }

  &__action-edit {
    background-image: url(/static/images/icon-edit-alt.svg);
    background-size: 14px;
  }

  &__action-delete {
    background-image: url(/static/images/icon-delete-alt.svg);
    background-size: 12px;
  }

  &__btn-transfer {
    width: 32px;
    height: 32px;
    border-radius: 4px;
  }

  &__container {
    margin-top: 2em;

    .order-state-button {
      &__FAILED {

        &--CORRECT,
        &--FIXED,
        &--ERROR {
          background-color: #f5a623;
          color: white;
          cursor: not-allowed !important;
          pointer-events: none;
        }
      }

      &__PENDING-TRANSMISSION,
      &__VALIDATED {

        &--CORRECT,
        &--FIXED {
          background-color: #7f1a54;
          color: white;

          &:hover {
            background-color: #691043;
          }
        }

        &--ERROR {
          background-color: #F0F0F0;
          color: #b8b7bf;
          pointer-events: none;
          cursor: not-allowed !important;
        }
      }

      &__TRANSFERRING {

        &--CORRECT,
        &--FIXED,
        &--ERROR {
          background-color: #ffffff;
          color: #f5a623;
          cursor: progress !important;
          pointer-events: none;
        }
      }

      &__RECEIVED {

        &--CORRECT,
        &--FIXED,
        &--ERROR {
          background-color: #ffffff;
          color: #b8b7bf;
          pointer-events: none;
          cursor: not-allowed !important;
        }
      }
    }

    .status {
      &-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }

      &-symbol {
        font-family: Roboto, sans-serif;
        font-size: 20px;
        letter-spacing: 1.33px;
        text-transform: uppercase;
        font-weight: 900;
        margin-right: 8.5px;
      }

      &-text {
        font-family: Roboto, sans-serif;
        font-size: 10px;
        letter-spacing: 1.33px;
        text-transform: uppercase;
        font-weight: 900;
      }
    }

    .order-status {
      &--ERROR {
        color: #9c0203;
      }

      &--CORRECT {
        color: #47ba8d;
      }

      &--FIXED {
        color: #f5a623;
      }
    }

    .apoio-datatable {
      margin-top: 0;

      &__line {
        height: 56px;
      }
    }

    .column {
      &-check {
        width: 45px;
        padding: 0 0 0 24px;
      }

      &-status {
        width: 45px;

        div {
          width: 10px;
          height: 10px;
          border-radius: 100%;
          background: #efefef;
        }

        .correct {
          background: #47BA8D
        }

        .error {
          background: #B40607
        }

        .fixed {
          background: #F5A623
        }
      }

      &-date {
        width: 80px;
      }

      &-transfer {
        width: 5%;
        text-align: center;
        padding: 10px 0;
      }

      &-date {
        width: 80px;
      }

      &-cpf {
        width: 115px;
      }

      &-treatment {
        width: 115px;
      }

      &-diabetes {
        width: 100px;
      }

      &-collect-time {
        width: 194px;
      }

      &-actions {
        width: 7%;
        text-align: center;
        padding: 10px 0;
      }

      &-exams {
        width: 2%;
        text-align: center;
        padding: 10px 0;
      }

      &-pacient {
        width: 19%;
      }

      &-document {
        text-align: center;
        max-width: 80px;
        width: 5%;
      }

      &-status {
        width: 30px;
        text-align: center;
      }
    }

    .covax-label {
      max-width: 10.5em;
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      width: inherit;
      white-space: nowrap;
      max-height: 1.3em;
    }

    .order-actions {
      display: none;
    }

    .actionshowing {
      display: block !important;
    }

    .notclicable {
      pointer-events: none !important;
    }

    .criticism-messages {
      position: absolute;
      cursor: help;
      right: 10px;

      @media all and (-ms-high-contrast: none),
      (-ms-high-contrast: active) {
        /* IE10 & IE11 CSS styles go here */
        top: -4px;
      }

      .md-icon {
        font-size: 1.6em;
        color: #f5a623;
      }
    }
  }
}

.custom-tooltip {
  ul li {
    list-style-type: circle;
    width: 420px;
    white-space: normal;
  }

  padding: 2% 3%;
  font-size: 12px;
  width: 470px;
}

.column-actions {
  width: 110px !important;
}
</style>
